/* @flow */

// eslint-disable-next-line import/prefer-default-export
export const SIGNING_MODES = {
  DEFAULT: 0,
  TREZOR: 1,
};
